export default __webpack_public_path__ + "static/usalogo-488c875315947a64604d976e003cbcde.svg";